import { action, observable, computed } from "mobx";
import { post } from "../../services/ajax-calls.service";
import NumeralHelper from "../../helpers/NumeralHelper";


class MedicalProceduresStore {

    @observable highest_procedure = []
    @observable procedure_info = {}
    @observable procedure_claim = []
    @observable url = "/api/v1/medicalActions/procedures";
    @observable procedure_count = {}
    @observable count = 0;
    @observable filterValue = "";
    // @observable tiles = 0;

    @computed get tiles() {
        return parseInt(this.count % 100) > 0 ? parseInt(this.count / 100) + 1 : parseInt(this.count / 100);
    }
    @computed get tiles1() {
        return parseInt(this.procedure_count / 100) > 0 ? parseInt(this.procedure_count / 100) + 1 : 0;
    }

    @action indexsortbyasc(filter) {
        this.filterValue = filter;
        if (this.highest_procedure.length > 0) {

            if (filter == "procedure_description") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (a.procedure_description > b.procedure_description) return -1;
                    if (a.procedure_description < b.procedure_description) return 1;
                    return 0
                })
            }

            if (filter == "claims_count") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (parseInt(a.claims_count) > parseInt(b.claims_count)) return -1;
                    if (parseInt(a.claims_count) < parseInt(b.claims_count)) return 1;
                    return 0
                })
            }

            if (filter == "plan_pay") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (parseInt(a.Total_Plan_Pay) > parseInt(b.Total_Plan_Pay)) return -1;
                    if (parseInt(a.Total_Plan_Pay) < parseInt(b.Total_Plan_Pay)) return 1;
                    return 0
                })
            }

            if (filter == "Patient_Responsibility") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (parseInt(a.Patient_Responsibility) > parseInt(b.Patient_Responsibility)) return -1;
                    if (parseInt(a.Patient_Responsibility) < parseInt(b.Patient_Responsibility)) return 1;
                    return 0
                })
            }
            if (filter == "participant_count") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (parseInt(a.participant_count) > parseInt(b.participant_count)) return -1;
                    if (parseInt(a.participant_count) < parseInt(b.participant_count)) return 1;
                    return 0
                })
            }
            if (filter == "Total_Allowed") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (parseInt(a.Total_Allowed) > parseInt(b.Total_Allowed)) return -1;
                    if (parseInt(a.Total_Allowed) < parseInt(b.Total_Allowed)) return 1;
                    return 0
                })
            }
            if (filter == "copay") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (parseInt(a.copay) > parseInt(b.copay)) return -1;
                    if (parseInt(a.copay) < parseInt(b.copay)) return 1;
                    return 0
                })
            }
            if (filter == "coinsurance") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (parseInt(a.coinsurance) > parseInt(b.coinsurance)) return -1;
                    if (parseInt(a.coinsurance) < parseInt(b.coinsurance)) return 1;
                    return 0
                })
            }
            if (filter == "deductible") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (parseInt(a.deductible) > parseInt(b.deductible)) return -1;
                    if (parseInt(a.deductible) < parseInt(b.deductible)) return 1;
                    return 0
                })
            }
            if (filter == "category") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (a.category > b.category) return -1;
                    if (a.category < b.category) return 1;
                    return 0
                })
            }
            if (filter == "medicare_percent") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (parseInt(a.percent_of_medicare > 0 ? a.percent_of_medicare : 0) > parseInt(b.percent_of_medicare > 0 ? b.percent_of_medicare : 0)) return -1;
                    if (parseInt(a.percent_of_medicare > 0 ? a.percent_of_medicare : 0) < parseInt(b.percent_of_medicare > 0 ? b.percent_of_medicare : 0)) return 1;
                    return 0
                })
            }
        }
    }
    @action indexsortbydesc(filter) {
        this.filterValue = filter;
        if (this.highest_procedure.length > 0) {

            if (filter == "procedure_description") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (a.procedure_description < b.procedure_description) return -1;
                    if (a.procedure_description > b.procedure_description) return 1;
                    return 0
                })
            }

            if (filter == "claims_count") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (parseInt(a.claims_count) < parseInt(b.claims_count)) return -1;
                    if (parseInt(a.claims_count) > parseInt(b.claims_count)) return 1;
                    return 0
                })
            }

            if (filter == "plan_pay") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (parseInt(a.Total_Plan_Pay) < parseInt(b.Total_Plan_Pay)) return -1;
                    if (parseInt(a.Total_Plan_Pay) > parseInt(b.Total_Plan_Pay)) return 1;
                    return 0
                })
            }

            if (filter == "Patient_Responsibility") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (parseInt(a.Patient_Responsibility) < parseInt(b.Patient_Responsibility)) return -1;
                    if (parseInt(a.Patient_Responsibility) > parseInt(b.Patient_Responsibility)) return 1;
                    return 0
                })
            }
            if (filter == "participant_count") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (parseInt(a.participant_count) < parseInt(b.participant_count)) return -1;
                    if (parseInt(a.participant_count) > parseInt(b.participant_count)) return 1;
                    return 0
                })
            }
            if (filter == "Total_Allowed") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (parseInt(a.Total_Allowed) < parseInt(b.Total_Allowed)) return -1;
                    if (parseInt(a.Total_Allowed) > parseInt(b.Total_Allowed)) return 1;
                    return 0
                })
            }
            if (filter == "copay") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (parseInt(a.copay) < parseInt(b.copay)) return -1;
                    if (parseInt(a.copay) > parseInt(b.copay)) return 1;
                    return 0
                })
            }
            if (filter == "coinsurance") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (parseInt(a.coinsurance) < parseInt(b.coinsurance)) return -1;
                    if (parseInt(a.coinsurance) > parseInt(b.coinsurance)) return 1;
                    return 0
                })
            }
            if (filter == "deductible") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (parseInt(a.deductible) < parseInt(b.deductible)) return -1;
                    if (parseInt(a.deductible) > parseInt(b.deductible)) return 1;
                    return 0
                })
            }
            if (filter == "category") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                    if (a.category < b.category) return -1;
                    if (a.category > b.category) return 1;
                    return 0
                })
            }
            if (filter == "medicare_percent") {
                this.highest_procedure = this.highest_procedure.sort(function (a, b) {
                   if (parseInt(a.percent_of_medicare > 0 ? a.percent_of_medicare : 0) < parseInt(b.percent_of_medicare > 0 ? b.percent_of_medicare : 0)) return -1;
                   if (parseInt(a.percent_of_medicare > 0 ? a.percent_of_medicare : 0) > parseInt(b.percent_of_medicare > 0 ? b.percent_of_medicare : 0)) return 1;
                   return 0
                })
            }
        }
    }

    @action sortby(filter) {
        this.filterValue = filter;
        if (this.procedure_claim.length > 0) {
            if (filter == "total_charges") {
                this.procedure_claim = this.procedure_claim.sort(function (c, d) {
                    if (parseInt(c.total_charges) > parseInt(d.total_charges)) return -1;
                    if (parseInt(c.total_charges) < parseInt(d.total_charges)) return 1;
                    return 0
                })
            }
            if (filter == "total_allowed") {
                this.procedure_claim = this.procedure_claim.sort(function (c, d) {
                    if (parseInt(c.total_allowed) > parseInt(d.total_allowed)) return -1;
                    if (parseInt(c.total_allowed) < parseInt(d.total_allowed)) return 1;
                    return 0
                })
            }
            if (filter == "total_plan_pay") {
                this.procedure_claim = this.procedure_claim.sort(function (c, d) {
                    if (parseInt(c.total_plan_pay) > parseInt(d.total_plan_pay)) return -1;
                    if (parseInt(c.total_plan_pay) < parseInt(d.total_plan_pay)) return 1;
                    return 0
                })
            }
            if (filter == "patient_responsibility") {
                this.procedure_claim = this.procedure_claim.sort(function (c, d) {
                    if (parseInt(c.patient_responsibility) > parseInt(d.patient_responsibility)) return -1;
                    if (parseInt(c.patient_responsibility) < parseInt(d.patient_responsibility)) return 1;
                    return 0
                })
            }
        }
    }
    @action getProceduresCount = async (data) => {
        this.count = 0;
        try {
            let response = await post(
                `${this.url}/getProceduresCount`,
                data
            );
            this.count = response.data.total_procedures;
            this.tiles =
                this.count % data.limit
                    ? parseInt(this.count / data.limit)
                    : parseInt(this.count / data.limit) + 1;


        } catch (err) {
            console.log(err);
        }
    }

    @action getHighestProcedures = async (data) => {
        this.highest_procedure = [];
        try {
            let response = await post(
                `${this.url}/getHighestProcedures`,
                data
            );
            this.highest_procedure = response.data;

        } catch (err) {
            console.log(err);
        }
    }

    @action getProcedureInfo = async (data) => {
        this.procedure_info = {};
        try {
            let response = await post(
                `${this.url}/getProcedureInfo`,
                data
            );
            this.procedure_info = response.data[0];
            this.procedure_count = response.data[0]?.claims_count;


        } catch (err) {
            console.log(err);
        }
    }

    @action getProcedureClaims = async (data) => {
        this.procedure_claim = [];
        try {
            let response = await post(
                `${this.url}/getProcedureClaims`,
                data
            );
            this.procedure_claim = response.data;

        } catch (err) {
            console.log(err);
        }
    }
}

export default MedicalProceduresStore;
